// Sentry
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

function configureSentry(App, router, origins) {
  // Init Sentry
  Sentry.init({
    App,
    dsn: process.env.MIX_SENTRY_DSN,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: origins.concat([/^\//]),
      }),
    ],
    environment: Laravel.app.env,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });

  // Set User
  if (Laravel.user) {
    Sentry.setUser({
      id: Laravel.user.id,
      email: Laravel.user.email,
    });
  }
}

export default configureSentry;
